import React from 'react';
import styled from 'styled-components';
import { constants } from '../../constants/index';

const StyledDiv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 20px 10px 15px 30px;
    width: 90%;

    @media (max-width: ${props => (props.mediaQ1) ? props.mediaQ1 : '0'}px){
        flex-direction: column; 
        align-items: start;
    }
`;

const ServiceCardListInnerContainer = ({ styles, onClick, children, ...rest }) => (
    <StyledDiv style = {styles}  onClick = {onClick} {...rest} >
        { children }
    </StyledDiv>
)

export default ServiceCardListInnerContainer


// WEBPACK FOOTER //
// ./src/js/components/ServiceCardList/ServiceCardListInnerContainer.jsx